import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, FormGroup, H2, H4, HTMLSelect,Icon,Toaster } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
import DetailByCorpus from './DetailByCorpus';
import {estimatedClass} from './common'
import './Stat.css';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME,FRONT_USER_ROLE_COOKIE_NAME } from '../../../auth/constants';

class StatByCorpus extends React.PureComponent {

  state = {
    detailStats: this.props.detailStats // specByDoc, freqByDoc, freqByReal, dispByReal
  }

  refHandlers = {
    toaster: (ref) => this.toaster = ref,
  };

  onDetailChange = (e) => {
    e.preventDefault();
    this.setState({ detailStats: e.target.value });
  }
  showIncompleteResultWarningToast = () => {

    this.toaster.show({
      message: this.props.t('onlyASampleOfTheCorpusHasBeenSearched'),
      intent: 'warning',
      icon: 'warning-sign',
    });
  }

  render() {
    const { corpusStats, t, estimatedResults } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    const userPlus = (Cookies.get(FRONT_USER_ROLE_COOKIE_NAME)==='user+') ? true: false ;

    let parsedClass="";
    // the json file may mix string and int format
    if (estimatedResults) {
      parsedClass="warn";
    } 

    return(
    <>
      <Paper className="margin-bottom-1-rem padding-1-rem">
        { this.props.displayShortName &&
          <div style={{color:"green",marginBottom:"20px"}}>{t('subCorpusName')} : {this.props.name}</div>
        } 
        <div className="flex">
          <div className="flex-one-third">
            <H2>{t('searchSpace')}</H2>
            <ul>

              <li>{t('tokenNumberColon')} { Intl.NumberFormat(langFormat).format(corpusStats.size)}</li>
              <li>{t('sentencesToParseColon')} {Intl.NumberFormat(langFormat).format(corpusStats.nbSents2Parse)}</li>
              <li className={parsedClass}>{t('sentencesParsedColon')} {Intl.NumberFormat(langFormat).format(corpusStats.nbParsedSents)}
                &nbsp;
                {estimatedResults && <Icon icon="warning-sign" onMouseEnter={this.showIncompleteResultWarningToast} />}
              </li>
            </ul>
            {(estimatedResults) && 
              <div>
                <p className={parsedClass}>{t('onlyASampleOfTheCorpusHasBeenSearched')}</p>
                <Button onClick={ () => { this.props.performSearch({useCompleteSearch:true}) }}>{t('runAgain')}</Button>
              </div>
            }
            {(userPlus) && 
              <div>
                <Button onClick={ this.props.runMLM }>{t('runMLM')}</Button>
                <Button onClick={ this.props.runClusterMlm }>{t('runClusterMlm')}</Button>

              </div>
            }
          </div>
          <div className="flex-two-third">
            <H2>{t('query')}</H2>
            <div dangerouslySetInnerHTML={{__html:this.props.querySvg}}></div>
          </div>
        </div>
        <Toaster ref={this.refHandlers.toaster} />
      </Paper>

      <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('searchResults')}</H2>

        <div className="margin-bottom-1-rem">
          <H4><u>{t('syntheticStats')}</u></H4>
          <ul>
            { this.props.missingSubCorpora && this.props.missingSubCorpora.length > 0 && 
              <li>{t('missingSubCorpora')} {this.props.missingSubCorpora.join(", ")}</li>
            }
            <li>
              <span className={estimatedClass(corpusStats.freq,estimatedResults)}>
                  {t('frequencyColon')} { Intl.NumberFormat(langFormat).format(corpusStats.freq)}
              </span>
            </li>
            <li>{t('dispColon')} {Intl.NumberFormat(langFormat).format(corpusStats.disp)} {"("+this.props.dispCriterion+")"}</li>
          </ul>
        </div>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('type')} labelFor='statsDetails' inline={true}>
            <HTMLSelect id='statsDetails' name='statsDetails' onChange={this.onDetailChange} value={this.state.detailStats}>
              <option value='specByDoc'>{this.props.subCorpusDisplayByFile? t('specByFile'): t('specByDoc')}</option>
              <option value='freqByDoc'>{this.props.subCorpusDisplayByFile? t('freqByFile'): t('freqByDoc')}</option>
            </HTMLSelect>
          </FormGroup>
        </div>

 {/*        {(this.state.detailStats === 'freqByReal' || this.state.detailStats === 'dispByReal' || this.state.detailStats === 'specByReal') &&
          <DetailByReal
            corpusStats={corpusStats}
            type={this.state.detailStats}
            incompleteExtraction={estimatedResults}
            realSpec={this.props.realSpec}
          />
        }
 */}
        <DetailByCorpus
            corpusStats={corpusStats.byDoc}
            type={this.state.detailStats}
            incompleteExtraction={estimatedResults}
            dispCriterion={this.props.dispCriterion}
            csvDelimiter={this.props.csvDelimiter}
        />

      </Paper>
    </>
    );
  }
}

StatByCorpus.propTypes = {
  name: PropTypes.string,
  displayShortName : PropTypes.bool,
  corpusStats: PropTypes.object,
  realSpec: PropTypes.object,
  query: PropTypes.string,
  querySvg: PropTypes.string,
  detailStats: PropTypes.string,
  estimatedResults: PropTypes.bool,
  pasteQuery: PropTypes.func,
  performSearch: PropTypes.func,
  runMLM: PropTypes.func,
  runClusterMlm: PropTypes.func,
  dispCriterion: PropTypes.string,
  subCorpusDisplayByFile : PropTypes.bool,
  csvDelimiter: PropTypes.string,
  missingSubCorpora: PropTypes.array,
};

export default withTranslation()(StatByCorpus);
